import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import styles from './A_Logo.module.css';

interface A_LogoProps {
  variant: 'default' | 'withLabel';
  width?: number;
  height?: number;
}

export default function A_Logo({ variant, width, height }: A_LogoProps) {
  return (
    <>
      {variant === 'default' && (
        <div
          className={styles.logo_default_wrapper}
          style={{ width: width || 48, height: height || 49 }}
        >
          <Q_Icon.LogoIcon
            width={width || 48}
            height={height || 49}
            fill='none'
          />
        </div>
      )}
      {variant === 'withLabel' && (
        <div
          className={styles.logo_wrapper}
          style={{ width: width || 144, height: height || 26 }}
        >
          <Q_Icon.LogoWithLabelIcon
            width={width || 144}
            height={height || 26}
            fill='none'
          />
        </div>
      )}
    </>
  );
}
